export const roleTextMap: Record<string, string> = {
  admin: '管理员',
  member: '操作员',
  viewer: '只读用户',
  superadmin: '超级管理员',
}

export const roleColorMap: Record<string, string> = {
  admin: 'red',
  member: 'blue',
  viewer: 'default',
  superadmin: 'volcano',
}
